import { render, staticRenderFns } from "./AlertasPantalla.vue?vue&type=template&id=289274f4&scoped=true&"
import script from "./AlertasPantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertasPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AlertasPantalla.vue?vue&type=style&index=0&id=289274f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289274f4",
  null
  
)

export default component.exports